export default {
  "app-layout": () => import("/home/forge/app.getgreengold.com/layouts/AppLayout.vue").then(m => m.default || m),
  "outside-layout": () => import("/home/forge/app.getgreengold.com/layouts/OutsideLayout.vue").then(m => m.default || m)
}